var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1011 1058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-12,.cls-2{fill:none;}.cls-3{clipPath:url(#clipPath);}.cls-4{mask:url(#mask);}.cls-5{opacity:0.9;}.cls-6,.cls-7,.cls-8,.cls-9{fill:#fff;}.cls-6{fill-opacity:0.5;}.cls-7{fill-opacity:0.3;}.cls-8{fill-opacity:0.6;}.cls-9{fill-opacity:0.4;}.cls-10{opacity:0.1;}.cls-11{clipPath:url(#clipPath-2);}.cls-12{stroke:#fff;strokeWidth:1.76px;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 207.89,
    cy: 948.8,
    r: 1,
    gradientTransform: "matrix(0, 1011.85, 2353.36, 0, -2232334.15, -209970.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9d9d9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0.67,
    width: 1009.66,
    height: 1058
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: -858.62,
    y: -416.22,
    width: 3367.34,
    height: 2526.36,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask0_521_5396",
    "data-name": "mask0 521 5396"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -858.62,
    y: -416.22,
    width: 2792.69,
    height: 1858.21
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -843,
    y: -207.22,
    width: 3351.72,
    height: 2166.59
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 853.56,
    cy: 752.85,
    r: 1.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 197.49,
    cy: 553.01,
    r: 2.33
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 18.85,
    cy: 615.99,
    r: 1.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 402.11,
    cy: 914.99,
    r: 1.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 927.05,
    cy: 813.63,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 7.67,
    cy: 453.79,
    r: 1.67
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 51.12,
    cy: 1032.95,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 360.75,
    cy: 269.58,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 36.66,
    cy: 136.25,
    r: 2.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 489.37,
    cy: 786.07,
    r: 1.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 700.68,
    cy: 722.37,
    r: 1.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 618.28,
    cy: 1035.79,
    r: 1.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 189.09,
    cy: 117,
    r: 1.87
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.39,1022.8a2.09,2.09,0,1,1-2.09,2.09A2.1,2.1,0,0,1,84.39,1022.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 639.45,
    cy: 898,
    r: 2.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 707.35,
    cy: 274.41,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 16.3,
    cy: 670.67,
    r: 2.35,
    transform: "translate(-654.47 681.65) rotate(-89.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 844.17,
    cy: 1056.62,
    r: 2.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 332.15,
    cy: 309.33,
    r: 1.86
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 1004.5,
    cy: 170.98,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 6.37,
    cy: 77.34,
    r: 1.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 615.09,
    cy: 258.46,
    r: 1.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 359.36,
    cy: 409.67,
    r: 2.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 304.01,
    cy: 1052.16,
    r: 2.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 556.35,
    cy: 210.84,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 130.68,
    cy: 963.08,
    r: 2.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 206.39,
    cy: 843.27,
    r: 1.69
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 211.39,
    cy: 873.71,
    r: 1.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 812.64,
    cy: 683.32,
    r: 2.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 429.03,
    cy: 860.84,
    r: 1.78
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 117.99,
    cy: 939.27,
    r: 2.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 505.42,
    cy: 612.96,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 954.06,
    cy: 314.47,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 82.87,
    cy: 492.44,
    r: 2.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 140.22,
    cy: 632.44,
    r: 2.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 623.34,
    cy: 885.07,
    r: 2.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 98.59,
    cy: 23.32,
    r: 1.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 966.71,
    cy: 514.7,
    r: 2.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 211.63,
    cy: 236.51,
    r: 2.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 830.14,
    cy: 673.8,
    r: 2.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 952.04,
    cy: 72.42,
    r: 1.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 46.46,
    cy: 107.9,
    r: 2.31
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 298.64,
    cy: 728.87,
    r: 1.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 655.26,
    cy: 155.56,
    r: 2.29
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 325.84,
    cy: 713.15,
    r: 1.92
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 729.87,
    cy: 600.55,
    r: 2.19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 616.93,
    cy: 1053.52,
    r: 2.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 938.03,
    cy: 102.93,
    r: 2.11
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 769.25,
    cy: 202.79,
    r: 1.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 351.51,
    cy: 581.45,
    r: 2.15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 152.71,
    cy: 568.63,
    r: 2.05
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 734.74,
    cy: 1012.36,
    r: 2.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 821.6,
    cy: 1035.64,
    r: 1.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 659.56,
    cy: 228.22,
    r: 1.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 433.76,
    cy: 43.75,
    r: 1.74
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 667.57,
    cy: 673.37,
    r: 1.88
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 607.56,
    cy: 840.68,
    r: 2.27
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 23.81,
    cy: 589.16,
    r: 1.91
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 877.68,
    cy: 169.74,
    r: 2.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 324.49,
    cy: 333.47,
    r: 2.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 421.68,
    cy: 154.06,
    r: 2.37
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 464.17,
    cy: 269.68,
    r: 1.95
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 307.06,
    cy: 681.65,
    r: 2.21
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 279.85,
    cy: 153.71,
    r: 2.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 441.74,
    cy: 908.53,
    r: 1.77
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 74.41,
    cy: 272.56,
    r: 1.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 530.86,
    cy: 716.29,
    r: 1.87
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 488.21,
    cy: 83.89,
    r: 2.14
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 108.04,
    cy: 2.57,
    r: 1.89
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 262.62,
    cy: 160.33,
    r: 2.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 532.22,
    cy: 700.16,
    r: 1.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 262.35,
    cy: 842,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 148.09,
    cy: 816.76,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 778.68,
    cy: 154.99,
    r: 1.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 929.69,
    cy: 921.18,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 484.82,
    cy: 174.29,
    r: 1.93
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: -1.42,
    cy: 446.3,
    r: 2.12,
    transform: "translate(-447.72 444.41) rotate(-89.94)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 678.47,
    cy: 803.49,
    r: 1.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 718.79,
    cy: 370.11,
    r: 2.23
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 905.83,
    cy: 3.96,
    r: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 159.09,
    cy: 201.45,
    r: 2.08
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 211.12,
    cy: 24.58,
    r: 1.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 326.13,
    cy: 204.76,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 484.6,
    cy: 887.81,
    r: 1.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 531.02,
    cy: 862.69,
    r: 2.04
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 336.65,
    cy: 14.99,
    r: 1.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 143.19,
    cy: 295.24,
    r: 2.07
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 661.31,
    cy: 433.43,
    r: 1.97
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 580.24,
    cy: 899.2,
    r: 1.98
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 341.68,
    cy: 272.77,
    r: 1.86
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M56.82-207.22V2110.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M169.29-207.22V2110.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M281.77-207.22V2110.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M394.25-207.22V2110.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M506.73-207.22V2110.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M619.21-207.22V2110.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M731.68-207.22V2110.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M844.16-207.22V2110.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M956.64-207.22V2110.14"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-843,17.73H2508.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-843,130.21H2508.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-843,242.69H2508.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-843,355.17H2508.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-843,467.64H2508.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-843,580.12H2508.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-843,692.6H2508.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-843,805.08H2508.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-843,917.55H2508.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M-843,1030H2508.72"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.45c9be080c94d7e6df07bf473808dbee.svg";
export { ForwardRef as ReactComponent };